<template>
  <div class="mask_bg">
    <div class="home-longins">
      <div class="btnChange "   :class="{'filterbgs':  $route.path =='/' && grayTheme }" >
        <div
          @click="change(1)"
          class="phone_login"
          :class="activeLogin == 1 ? 'actives' : ''"
        >
          手机登录
        </div>
        <div class="line_class"></div>
        <div
          @click="change(2)"
          class="phone_login"
          :class="activeLogin == 2 ? 'actives' : ''"
        >
          账号登录
        </div>
        <div class="login_close">
          <img
            @click="Longins"

            class="icon2"
            referrerpolicy="no-referrer"
            src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png"
          />
        </div>
      </div>

      <el-form
        class="apply-form first-form "
        :model="userInfo"
         :class="{'filterbgs':  $route.path =='/' && grayTheme }"
        :rules="rule"
        ref="form"
      >
        <div v-if="activeLogin == 1">
          <el-form-item prop="mobile">
            <el-input
              class="myphone"
              v-model="userInfo.mobile"
              placeholder="请输入手机号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="token">
            <div class="getcodeBox">
              <el-input
                v-model="userInfo.token"
                class="mycode"
                :maxlength="18"
                placeholder="请输入验证码"
                clearable
              ></el-input>
              <div
                class="getCode"
                :class="btnTitle !== '获取验证码' ? 'opct2' : ''"
                @click="getCode"
              >
                {{ btnTitle }}
              </div>
            </div>
          </el-form-item>
        </div>

        <div v-if="activeLogin == 2">
          <el-form-item prop="account">
            <el-input
              class="myphone"
              v-model="userInfo.account"
              placeholder="请输入龙珠账号"
              autocomplete="off"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="userInfo.password"
              class="myphone"
              :maxlength="18"
              autocomplete="new-password"
              type="password"
              show-password
              placeholder="请输入密码"
              clearable
            ></el-input>
          </el-form-item>
        </div>

        <el-button @click="btnLogin" type="primary" class="btnLogins"
          >登录</el-button
        >
      </el-form>
      <div style="width:100%;height:90px;margin-top:20px;" :class="{'filterbgs': $route.path =='/' && grayTheme }" >
          <div style="width:100%;font-size:12px;text-align: center;color: #999999;">
            其他方式
          </div>
          <div style="display:flex;justify-content: center;margin-top:10px;">
            <div style="display:flex;width:110px;justify-content: space-between;">
              <div style="width:35px;cursor:pointer;font-size:12px;text-align:center" @click="weixindenglu()">
                <img src="https://oss.ansongqiubo.com/assets/longin/wx.png" /> <br>
                <span>微信</span>
              </div>
              <div style="width:35px;text-align: center;cursor:pointer;font-size:12px;" @click="qqdenglu()">
                <img src="https://oss.ansongqiubo.com/assets/longin/qq.png" /> <br>
                QQ
                <span id="qqLoginBtn"></span>
              </div>
            </div>
          </div>
        </div>
      <div class="emit_regs "  :class="{'filterbgs': $route.path =='/' && grayTheme }" >*手机号验证成功后自动注册</div>
      <!-- <div class="home-longin-div6">
          <input style="width: 20px;height:20px;" type="checkbox" v-model="tongyi">
          <span>我已阅读并同意</span>
          <a href="http://h5.ansongqiubo.com/h5/userregegistry.html" target="_Blank">《用户注册协议》</a>
          <a href="http://h5.ansongqiubo.com/h5/privatepolicy.html" target="_Blank">《隐私政策》</a>
          <a href="http://h5.ansongqiubo.com/h5/longzhulive.html" target="_Blank">《儿童/青少年个人信息保护规则》</a>
          <a href="http://h5.ansongqiubo.com/h5/chinamobile.html" target="_Blank">《中国移动认证服务条款》</a>
        </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  props: ["long"],
  inject: ["reload"],

  data() {
    let reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,12}$/;
    var validateNewPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error("密码应是6-12位数字、字母或字符！"));
      } else if (this.form.oldPasswd === value) {
        callback(new Error("新密码与旧密码不可一致！"));
      } else {
        callback();
      }
    };
    var validateComfirmPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error("密码应是6-12位数字、字母或字符！"));
      } else if (this.form.newPasswd !== value) {
        callback(new Error("确认密码与新密码不一致！"));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      if(value.indexOf('220') >=0){
        callback();
        return
      }


      if (!/^1[23456789]\d{9}$/.test(value)) {
        callback(new Error("手机号码有误，请重填"));
      } else {
        callback();
      }
    };
    return {
      routerPath:'/',
      btnTitle: "获取验证码",
      activeLogin: 1, // 2 手机号  1 验证码  3 微信扫码
      rule: {
        // newPasswd: [
        //   { required: true, message: "请输入新密码", trigger: "blur" },
        //   { validator: validateNewPwd, trigger: "blur" },
        // ],
        // comfirmPwd: [
        //   { required: true, message: "请输入确认密码", trigger: "blur" },
        //   { validator: validateComfirmPwd, trigger: "blur" },
        // ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
          // {
          //   required: true,
          //   pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          //   message: "姓名不支持特殊字符",
          //   trigger: "blur",
          // },
        ],
        token: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            min: 2,
            max: 6,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
          {
            required: true,
            pattern: /(^\d)/,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },
      timer:null,
      openSMCaptcha:true,
      smsCode:'',
      userInfo: {
        mobile: "",
        token: "",
        account: "",
        password: "",
      },
    };
  },
  methods: {
    updataName() {
      console.log('打开修改昵称弹框', );
      this.$emit('updataName')
    },
          // qq登录
      qqdenglu(){
        // let redirect = this.common.GetParam(location.href,'redirect')
        console.log(QC);
        QC.Login.showPopup({
          addId:"101992980",
          redirectURI:"https://www.longzhulive.com/binduser"
        })
      },
      // 微信登录事件
      weixindenglu(){
        const that = this
        // 分类列表
        // 获取域名
        console.log(window.location.host);
        // 获取完整url地址
        console.log(window.location.href);
       that.$axios.get(that.api+'/v1/third/wechat?redirectUri=https://www.longzhulive.com', {
        }).then((res) => {
          // console.log(res);
          window.open(res.data.data.targetUrl)
        })
      },
      SMCSHUmei(){
            /**
             * 数美验证码回调
             * @param SMCaptcha
             */
            let that  = this;
            // 初始化验证码
            var params = {
                organization: 'sLs4nifpjXY4o1KN06Zp', //线上测试公司
                product: 'popup',
                width: 300,
                https: true,
                onError: function (errType, errmMsg) {
                    console.log('onError!',errmMsg,errType);
                },
                onInit: function (captchaUuid) {
                    console.log('初始化成功', captchaUuid);
                },
                maskBindClose:false,
            };
            initSMCaptcha(params,(SMCaptcha)=>{
              //验证码校验情况回调
                SMCaptcha.onSuccess(function(data){
                  console.log('初始化回调3',data);
                  if(data.pass){
                    that.SMCaptcha.reset();
                    that.smsCode = data.rid;
                    that.openSMCaptcha = false;
                    that.getCode()
                  }
                    //这里可以获取前端验证状态,pass为true验证码前端验证成功;pass为false,前端验证失败,需要可以提醒用户
                });
                //资源加载异常,建议开发时进行监听,便于查询错误
                SMCaptcha.onError(function (errType,errMsg) {
                    //errType: SERVER_ERROR
                    //errMsg: {code: 2002, message: "服务器异常: 无权限操作(invalid organization)"}
                    console.log('onError', errType, errMsg);
                });
                that.SMCaptcha = SMCaptcha
            });
      },
    change(val) {
      this.activeLogin = val;
      this.$refs["form"].clearValidate();
    },
    btnLogin() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.activeLogin == 1) {
            this.ShoujihaoDenglu();
          }
          if (this.activeLogin == 2) {
            this.ZhanghaoDenglu();
          }
        } else {
          this.$message({
          message: "请检查输入内容",
          type: "warning",
        });
          return false;
        }
      });
    },
    requestError(code){
      if(code == 20334){
        console.log('弹出滑块验证。。。。。。。。。。。。。。。。。。。。。。。。。。。');
        this.SMCaptcha.verify();
      }
    },
    getCode() {




      let reg = /^1[23456789]\d{9}$/;
      if (
        !this.userInfo.mobile ||
        !this.userInfo.mobile.length == 11 ||
        !reg.test(this.userInfo.mobile)
      ) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }

      if(this.openSMCaptcha){
        this.SMCaptcha.verify();
        return
      }

      if (this.timer) {
        this.$message({
          message: "不能重复点击！",
          type: "warning",
        });
        return;
      }

      this.$axios({
        headers: {
          device: "iOS",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "Content-Type": "application/x-www-form-urlencoded",
          "captchaRid":this.smsCode?this.smsCode:''
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/login/mobileSmsCode",
        method: "post",
        data: {
          mobile: this.userInfo.mobile,
        },
      }).then((res) => {
        if(res.data.code == 200){
          this.$message({
            message: "验证码发送成功！",
            type: "success",
          });
          let time = 60;
          this.timer = setInterval(() => {
            if (time <= 0) {
              clearInterval(this.timer);
              this.timer = null
              this.btnTitle = "获取验证码";
            } else {
              this.btnTitle = time + "s";
              time--;
            }
          }, 1000);
        }else{
          this.$message.errMsg(res.data.message)
        }

      });
    },
    // 自己写的正则验证,限制用户输入数字以外的字符
    // 过滤输入的金额
    InputNumber(property) {
      this.registData[property] = this.limitInputPointNumber(
        this.registData[property]
      );
    },
    // 验证只能输入数字
    limitInputNumber(val) {
      if (val) {
        return String(val).replace(/\D/g, "");
      }
      return val;
    },
    // 限制只能输入数字(可以输入两位小数)
    limitInputPointNumber(val) {
      if (val === 0 || val === "0" || val === "") {
        return "";
      } else {
        let value = null;
        value = String(val).replace(/[^\d.]/g, ""); // 清除“数字”和“.”以外的字符
        value = value.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
        value = value
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
        value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
        return Number(value);
      }
    },
    Longins() {
      this.$emit("longi", false);
      this.btnTitle = "获取验证码";
      clearInterval(this.timer);
    },
    Yanzheng() {
      this.yanzheng = true;
      this.zhanghao = false;
      // this.forget = false;
    },
    Zhanghao() {
      this.yanzheng = false;
      this.zhanghao = true;
      // this.forget = false;
    },
    Forget() {
      this.denglu = false;
      // this.yanzheng = false;
      this.forget = true;
    },
    ShoujihaoVerify() {
      this.botton1 = false;
      this.botton2 = true;
      if (this.botton2 == true) {
        let time = 60;
        this.timer = setInterval(() => {
          if (time == 0) {
            clearInterval(this.timer);
            // this.btnTitle ="获取验证码";
            this.botton1 = true;
            this.botton2 = false;
          } else {
            this.btnTitle = time + "s";
            this.disabled = true;
            time--;
          }
        }, 1000);
      }
      this.$axios({
        headers: {
          device: "iOS",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/login/mobileSmsCode",
        method: "post",
        data: {
          mobile: this.userInfo.mobile,
        },
      }).then((res) => {
        console.log(res);
      });
    },
    ShoujihaoDenglu() {
      // window._czc.push(['A0005', "点击", "用户手机验证码登陆"])
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/login/mobile",
        method: "post",
        data: {
          mobile: this.userInfo.mobile,
          token: this.userInfo.token,
        },
      }).then((res) => {
        if (res.data.message == "success") {
          localStorage.setItem("token", res.data.data.lzid);
          // 是否第一次登录
          this.$store.dispatch('getUserInfoData',2).then((result) => {
            console.log('获取用户信息00', result);
            this.$message({
              message: '登录成功',
              type: "success",
            });
            this.$emit("longi", true);
            if(res.data.data.userBehavior == 'register'){
              this.updataName()
            }else{
              this.reload();
            }
          });

        } else {
          this.requestError(res.data.code)
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    ZhanghaoDenglu() {
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/login/account",
        method: "post",
        data: {
          account: this.userInfo.account,
          password: this.userInfo.password,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.message == "success") {
          localStorage.setItem("token", res.data.data.lzid);
          this.$store.dispatch('getUserInfoData',2).then((result) => {
            console.log('获取用户信息00', result);
            this.$message({
              message: '登录成功',
              type: "success",
            });
            this.$emit("longi", true);
            if(res.data.data.userBehavior == 'register'){
              this.updataName()
            }else{
              this.reload();
            }
          });
        } else {
          this.requestError(res.data.code)
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
  },
  created() {
    this.routerPath = this.$route.path
    clearInterval(this.timer);
    setTimeout(()=>{
      this.SMCSHUmei()
    },1200)
  },
  computed: {
    grayTheme(){
      let data = JSON.parse(localStorage.getItem('userSettingInfo') || {}) ; // grayTheme
      return data && data.grayTheme
    }
  },
};
</script>

<style scoped lang='scss'>
.mask_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  z-index: 1006;
  background-color: rgba(0, 0, 0, 0.3);
}
.home-longins {
  width: 360px;
  // height: 334px;
  background: #ffffff;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 20px;
  position: absolute;
  box-sizing: border-box;
  left: 50%;
  top: 40%;
  z-index: 1100;
  transform: translate(-50%, -50%);
  .opct2 {
    opacity: 0.8 !important;
  }
  .emit_regs {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 10px;
  }
  .btnLogins {
    width: 312px;
    height: 42px;
    background: #721edc;
    border-radius: 4px;
  }
  .login_close {
    display: flex;
    justify-content: flex-end;
    width: 20px;
    flex: 2;
    img {
      width: 20px;
      height: 20px;
      transform: rotate(0deg);
      transition: all 0.2s;
    }
    img:hover {
      transform: rotate(90deg);
      transition: all 0.2s;
    }
  }
  .getcodeBox {
    display: flex;
    align-items: center;
    .mycode {
      max-width: 198px;
    }
    .myphone {
      max-width: 312px;
      color: #333333;
    }
  }

  .btnChange {
    display: flex;
    margin-bottom: 32px;
    align-items: center;
    .actives {
      color: #721edc !important;
    }
    .line_class {
      height: 100%;
      height: 16px;
      width: 2px;
      background-color: rgba(0, 0, 0, 0.1);
      margin: 0 12px;
    }
    .phone_login {
      cursor: pointer;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }
  .getCode {
    width: 114px;
    height: 42px;
    background: #721edc;
    border-radius: 4px;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
}
.home-longin-div1 {
  height: 38px;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: right;
  align-items: center;
}
.icon2 {
  width: 28px;
  height: 28px;
}
.home-login-h1 {
  width: 352px;
  height: 44px;
  display: block;
  color: #333333;
  font-size: 44px;
  white-space: nowrap;
  line-height: 44px;
  text-align: left;
  align-self: flex-start;
  margin-top: 10px;
}
.home-login-div2 {
  width: 330px;
  height: 32px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
}
.home-login-div2-div1 {
  width: 150px;
  height: 32px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 30px;
  white-space: nowrap;
  line-height: 32px;
  text-align: right;
  cursor: pointer;
}
.home-login-div2-div1-div {
  width: 80px;
  height: 6px;
  border-radius: 3px;
  background-color: rgba(214, 181, 255, 1);
  align-self: flex-start;
  margin-left: 30px;
  margin-top: 5px;
}
.home-login-div2-div1-div2 {
  width: 80px;
  height: 6px;
  border-radius: 3px;
  background-color: rgba(214, 181, 255, 1);
  align-self: flex-start;
  margin-left: 18px;
  margin-top: 5px;
}
.home-login-div2-div2 {
  /* z-index: 225; */
  width: 120px;
  height: 32px;
  display: block;
  cursor: pointer;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 30px;
  font-family: PingFangSC-Regular;
  white-space: nowrap;
  line-height: 32px;
  text-align: right;
}
.home-input1 {
  width: 450px;
  height: 60px;
  font-size: 22px;
  border: none;
  margin-top: 16px;
  background-color: rgba(239, 239, 239, 1);
  justify-content: center;
  align-items: flex-start;
  border-radius: 6px;
  outline: none;
  padding-left: 20px;
}
.home-longin-eye {
  position: absolute;
  top: 63%;
  right: 5%;
}
.home-longin-eye2 {
  position: absolute;
  top: 50%;
  right: 5%;
}
.home-input2 {
  width: 300px;
  height: 60px;
  font-size: 23px;
  padding-left: 20px;
  border: none;
  margin-top: 16px;
  background-color: rgba(239, 239, 239, 1);
  justify-content: center;
  align-items: flex-start;
  border-radius: 6px;
  outline: none;
}
.home-input3 {
  width: 450px;
  height: 60px;
  font-size: 22px;
  border: none;
  margin-top: 16px;
  background-color: rgba(239, 239, 239, 1);
  justify-content: center;
  align-items: flex-start;
  border-radius: 6px;
  outline: none;
  padding-left: 20px;
}
.home-button2 {
  height: 60px;
  border-radius: 0 6px 6px 0;
  background-color: rgba(114, 30, 220, 1);
  width: 174px;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  font-size: 23px;
  outline: none;
  border: 0px;
  color: white;
  cursor: pointer;
}
.home-button2-boton {
  height: 60px;
  border-radius: 0 6px 6px 0;
  background-color: #be9df9;
  width: 174px;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  font-size: 23px;
  outline: none;
  border: 0px;
  color: white;
}
.home-longin-botton3 {
  height: 72px;
  border-radius: 6px;
  cursor: pointer;
  background-color: #d4b2ff;
  margin-top: 90px;
  width: 470px;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: white;
  outline: none;
  border: 0px;
}
.home-longin-botton4 {
  height: 72px;
  border-radius: 6px;
  background-color: #d4b2ff;
  margin-top: 20px;
  width: 470px;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: white;
  outline: none;
  border: 0px;
}
.home-longin-div3 {
  width: 471px;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 20px;
  font-family: PingFangSC-Regular;
  white-space: nowrap;
  line-height: 20px;
  text-align: left;
  align-self: flex-start;
  margin-top: 10px;
}
.home-longin-div4 {
  width: 552px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
}
.home-longin-div5 {
  width: 260px;
  height: 70px;
  justify-content: space-between;
  margin: 20px 0 0 146px;
  display: flex;
}
/* .home-longin-div5-img1{
      width: 63px;
      height: 63px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng8959e4d110c9d051d2eb481f0467f5fd129a4dadb3d5ec3c620c95a896653d69)
      0px 0px no-repeat;
    }
    .home-longin-div5-img2{
      width: 63px;
      height: 63px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng3c590e119d12d3a655019da827610369edc2b9aa29a6e810b180647d24870d09)
      0px 0px no-repeat;
    } */
.home-longin-div6 {
  width: 470px;
  height: 53px;
  margin-top: 43px;
  justify-content: space-between;
}
.home-longin-div6 > a {
  text-decoration: none;
  color: #721edc;
}
.forget-div1 {
  width: 162px;
  height: 14px;
  color: red;
  font-size: 14px;
  text-align: left;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/component/Longin.vue